$(function () {
    $('#berakna-itp2').on('click', function (evt) {
        $('#berakna-itp2').addClass('knapp-laddar');
        $('.itp2-felmeddelande, .itp2-fel-alder, .itp2-resultat, .itp2-fel-pensionar, .itp2-fel-snart-pensionar, .itp2-maxbelopp').hide();

        var datum = $('#Berakningsparametrar_Fodelsedatum').val();
        var lon = $('#Berakningsparametrar_Lon').val();
        var requestdata = {fodelsedatum: datum, lon: lon};

        var form = evt.target.form;
        var validator = $(form).validate();

        if (validator.valid()) {
            $.ajax({
                type: 'POST',
                url: '/webapi/berakning/beraknaschablon',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(requestdata),
                dataType: 'json',
                success: function (data) {
                    window.mustacheUi.toHtml({lon: lon}, '.mustache-target-svar1', '.mustache-template-svar1');
                    window.mustacheUi.toHtml({lon: lon}, '.mustache-target-svar2', '.mustache-template-svar2');
                    window.mustacheUi.toHtml({lon: lon}, '.mustache-target-svar3', '.mustache-template-svar3');
                    window.mustacheUi.toHtml({lon: lon}, '.mustache-target-svar4', '.mustache-template-svar4');

                    if (data.OverMaxbelopp) {
                        $('.itp2-maxbelopp').show();
                    }

                    $('#hogre-itp2-belopp').html(data.PremieLitetIntjanat + ' kr/mån');
                    $('#samma-itp2-belopp').html(data.PremieNormaltIntjanat + ' kr/mån');
                    $('#lagre-itp2-belopp').html(data.PremieStortIntjanat + ' kr/mån');
                    $('#inget-itp2-belopp').html(data.PremieIngetIntjanat + ' kr/mån');

                    $('.itp2-resultat').show();
                },
                complete: function () {
                    $('#berakna-itp2').removeClass('knapp-laddar');
                },
                error: function (jqXHR) {
                    var alternativflodeAktiverat = false;
                    var ohanteratFelHarIntraffat = false;

                    try {
                        var data = JSON.parse(jqXHR.responseText);
                        var errors = {};
                        for (var key in data.ModelState) {
                            if (Object.prototype.hasOwnProperty.call(data.ModelState, key)) {
                                switch (key) {
                                case 'foddEfter1979':
                                    $('.itp2-fel-alder').show();
                                    alternativflodeAktiverat = true;
                                    break;
                                case 'forNara65':
                                    $('.itp2-fel-snart-pensionar').show();
                                    alternativflodeAktiverat = true;
                                    break;
                                case 'efter65':
                                    $('.itp2-fel-pensionar').show();
                                    alternativflodeAktiverat = true;
                                    break;
                                default:
                                    var sistaPunktensPosition = key.lastIndexOf('.') === -1 ? 0 : key.lastIndexOf('.') + 1;
                                    var inputName = 'Berakningsparametrar.' + key.substr(sistaPunktensPosition);
                                    errors[inputName] = data.ModelState[key][0];
                                }
                            }
                        }

                        if (jQuery.isEmptyObject(errors) && !alternativflodeAktiverat) {
                            ohanteratFelHarIntraffat = true;
                        } else {
                            validator.showErrors(errors);
                            validator.focusInvalid();
                        }
                    } catch (e) {
                        ohanteratFelHarIntraffat = true;
                    } finally {
                        if (ohanteratFelHarIntraffat) {
                            $('.itp2-felmeddelande').show();
                        }
                    }
                }
            });
        } else {
            validator.focusInvalid();
        }
    });
});
